import { Auth } from 'aws-amplify';
import { toast } from 'react-toastify';
import appConfig from '../../../../../config/app-config';

const { address: API_URL, key: API_KEY } = appConfig.apis.contractsManagementApiEnv;

export const useFileDownload = () => {
    const handleDownload = async (creditOperationId: string, fileName: string) => {
        try {
            const token = await Auth.currentSession().then((user) => user.getIdToken().getJwtToken());
            const response = await fetch(`${API_URL}/download/${creditOperationId}/${encodeURIComponent(fileName)}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'x-api-key': API_KEY || ''
                }
            });
            if (response.ok) {
                const data = await response.json();
                const a = document.createElement('a');
                a.href = data.url;
                a.download = data.filename || fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
            } else {
                toast.error('Erro ao baixar arquivo');
            }
        } catch (error: unknown) {
            const message = error instanceof Error ? error.message : 'Erro ao conectar com o servidor';
            toast.error(message);
        }
    };

    return { handleDownload };
};
